import { render, staticRenderFns } from "./switch-label.vue?vue&type=template&id=970075c4&scoped=true&lang=pug"
import script from "./switch-label.vue?vue&type=script&lang=js"
export * from "./switch-label.vue?vue&type=script&lang=js"
import style0 from "./switch-label.vue?vue&type=style&index=0&id=970075c4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970075c4",
  null
  
)

export default component.exports